import styled from "styled-components";

const Wrap = styled.div`
  width: 36rem;
  padding: 1.5rem;
`;

export default Wrap;
